import { Box, Typography } from "@tm/components"
import { useLocalization } from "@tm/localization"

export function EmptyCompilation() {
    const { translateText } = useLocalization()

    return (
        <Box alignSelf="center" alignItems="center" display="flex">
            <Typography>{translateText(1284)}</Typography>
        </Box>
    )
}
